import { GoldDivider, FloralOrnament } from "./Ornaments";
import CountdownTimer from "./CountdownTimer";

export default function HeaderSection({ details }) {
  return (
    <section data-testid="wedding-header-section" className="space-y-7 text-center">
      <FloralOrnament className="mx-auto opacity-90" />

      <p className="eyebrow">საქორწილო მოსაწვევი</p>

      <h1
        data-testid="couple-names-display"
        className="whitespace-nowrap text-[clamp(1.45rem,7.2vw,2.9rem)] leading-tight text-[#1C1917]"
      >
        {details.name1}
        <span className="font-script gold-text mx-2 align-middle text-[clamp(1.9rem,9vw,3.6rem)]">
          &amp;
        </span>
        {details.name2}
      </h1>

      <GoldDivider testid="wedding-ornate-divider" />

      <div
        data-testid="wedding-date-ornate-badge"
        className="gold-frame mx-auto inline-block bg-white px-8 py-4"
      >
        <p className="eyebrow mb-1.5 !text-[9px]">თარიღი</p>
        <p className="font-display gold-text text-lg uppercase tracking-[0.18em] sm:text-xl">
          {details.date}
        </p>
      </div>

      <CountdownTimer />
    </section>
  );
}
